import {css, StyleSheet} from 'aphrodite';
import React, {RefObject} from 'react';

import {pluralize} from 'BenchlingUtil';
import {GRAY_DARKER} from 'ui-library/Colors';

interface PlateMapSelectedWellsCount {
  selectedWellIndices: Set<number>;
  paragraphRef?: RefObject<HTMLParagraphElement>;
}

/**
 * Renders a count of the selected wells.
 */
export function PlateMapSelectedWellsCount({
  selectedWellIndices,
  paragraphRef,
}: PlateMapSelectedWellsCount): JSX.Element {
  return (
    <p className={css(styles.numSelected)} ref={paragraphRef}>
      {`${selectedWellIndices.size} ${pluralize(selectedWellIndices.size, 'well')} selected`}
    </p>
  );
}

const styles = StyleSheet.create({
  numSelected: {
    color: GRAY_DARKER,
    margin: 'auto 16px auto 0',
  },
});
